import { useEffect, useState } from 'react';
import { api } from '../../lib/api';
import { Spinner } from '../../components/Spinner';
import { formatRelative } from '../../lib/format';
import type { AuditLog } from '@shared/types';

export function AdminAuditPage() {
  const [data, setData] = useState<{ items: AuditLog[]; total: number } | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api
      .get<{ items: AuditLog[]; total: number }>('/api/admin/audit?pageSize=200')
      .then(setData)
      .catch((err) => setError(err instanceof Error ? err.message : String(err)));
  }, []);

  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-2xl font-bold tracking-tight">Audit log</h1>
        <p className="text-sm text-ink-500 dark:text-ink-400">
          A reverse-chronological feed of sensitive actions across the platform.
        </p>
      </header>
      {error && (
        <div className="rounded-lg bg-red-50 dark:bg-red-950/40 text-red-700 dark:text-red-200 px-4 py-3 text-sm">
          {error}
        </div>
      )}
      {!data && (
        <div className="flex items-center justify-center py-16">
          <Spinner size={28} />
        </div>
      )}
      {data && (
        <div className="table-wrap">
          <table className="data-table">
            <thead>
              <tr>
                <th>When</th>
                <th>Actor</th>
                <th>Action</th>
                <th>Target</th>
                <th>Org</th>
              </tr>
            </thead>
            <tbody>
              {data.items.map((a) => (
                <tr key={a.id}>
                  <td className="text-xs">{formatRelative(a.createdAt)}</td>
                  <td className="text-sm">{a.actorEmail ?? '—'}</td>
                  <td className="font-mono text-xs">{a.action}</td>
                  <td className="text-xs">
                    {a.targetType ? `${a.targetType}:${a.targetId ?? ''}` : '—'}
                  </td>
                  <td className="text-xs text-ink-500 dark:text-ink-400">
                    {a.organizationId ? `${a.organizationId.slice(0, 8)}…` : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
